import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { fetchOrderTreeData } from '../APis/myEarningsSlice'

const withOrderTreeData = (WrappedComponent) => {
	return function WithOrderTreeData(props) {
		const { orderTreeData } = useSelector((state) => state.myEarnings)
		const [searchTerm, setSearchTerm] = useState('')
		const [filteredData, setFilteredData] = useState([])
		const dispatch = useDispatch()
		const { orderId } = useParams()

		useEffect(() => {
			if (orderId) {
				dispatch(fetchOrderTreeData(orderId))
			}
		}, [orderId, dispatch])

		useEffect(() => {
			if (orderTreeData) {
				setFilteredData(orderTreeData)
			}
		}, [orderTreeData])

		const handleSearch = (value) => {
			setSearchTerm(value)

			if (value) {
				const searchUser = (users) => {
					return users?.reduce((acc, user) => {
						const matches = user?.registerId?.toLowerCase()?.includes(value?.toLowerCase())

						if (matches) {
							// Include this user and all its children
							acc.push({ ...user })
						} else if (user.users && user.users.length > 0) {
							// Check children recursively
							const matchedChildren = searchUser(user.users)
							if (matchedChildren.length > 0) {
								// Include this user with only the matched children
								acc.push({ ...user, users: matchedChildren })
							}
						}
						return acc
					}, [])
				}

				const searchResults = searchUser(orderTreeData)
				setFilteredData(searchResults)
			} else {
				setFilteredData(orderTreeData) // Reset to the original data if search is cleared
			}
		}

		return <WrappedComponent {...props} orderTreeData={filteredData} searchTerm={searchTerm} handleSearch={handleSearch} />
	}
}

export default withOrderTreeData
